import React from 'react';

// Renders text, highlighting [bracketed] placeholders as visible yellow gaps
// and turning http(s):// URLs into clickable links.
export const renderWithPlaceholders = (text) => {
  // Split on placeholders [..] and URLs (http/https) keeping delimiters
  const parts = String(text).split(/(\[[^\]]+\]|https?:\/\/[^\s]+)/g);
  return parts.map((part, i) => {
    if (part.startsWith('[') && part.endsWith(']')) {
      return (
        <mark
          key={i}
          data-testid="legal-placeholder"
          className="bg-[#F4D03F]/25 text-[#F4D03F] border border-[#F4D03F]/40 rounded px-1.5 py-0.5 mx-0.5 font-normal not-italic"
        >
          {part}
        </mark>
      );
    }
    if (/^https?:\/\//.test(part)) {
      return (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#D4AF37] hover:underline break-all"
        >
          {part}
        </a>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};
